import networkAdapter from '../adapters/network';

export const fetchFieldViewLayers = ( {userId} ) => {
  const legacyOptions = {
    url: '/api/fieldview/rest/fieldSpatialDefinition/fieldsByUserIds',
    userId,
    method: 'POST',
    body: JSON.stringify( { userIds: [`${userId}`] } ),
    redirectsToLoginOnAuthFail: false // if the auth errs, just roll with it.
  };
  
  return networkAdapter({
    legacyOptions
  });
};
